import type React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../components/app/Layout/Layout";
import DashboardPage from "../pages/app/DashboardPage/DashboardPage";
import GoalListPage from "../pages/app/GoalListPage/GoalListPage";
import GoalDetailPage from "../pages/app/GoalDetailPage/GoalDetailPage";
import GoalFormPage from "../pages/app/GoalFormPage/GoalFormPage";
import DiaryListPage from "../pages/app/DiaryListPage/DiaryListPage";
import DiaryFormPage from "../pages/app/DiaryFormPage/DiaryFormPage";
import DiaryDetailPage from "../pages/app/DiaryDetailPage/DiaryDetailPage";
import ProgressTrackerPage from "../pages/app/ProgressTrackerPage/ProgressTrackerPage";
import ProfilePage from "../pages/app/ProfilePage/ProfilePage";
import EventListPage from "../pages/app/EventListPage/EventListPage";
import EventDetailPage from "../pages/app/EventDetailPage/EventDetailPage";
import EventFormPage from "../pages/app/EventFormPage/EventFormPage";
import ChannelListPage from "../pages/app/ChannelListPage/ChannelListPage";
import ChannelDetailPage from "../pages/app/ChannelDetailPage/ChannelDetailPage";
import CalendarPage from "../pages/app/CalendarPage/CalendarPage";
import SearchResultPage from "../pages/app/SearchResultPage/SearchResultPage";
import PomodoroTimerPage from "../pages/app/PomodoroTimerPage/PomodoroTimerPage";
import NotificationsPage from "../pages/app/Settings/NotificationsPage/NotificationsPage";
import ProfileSettingsPage from "../pages/app/Settings/ProfilePage/ProfilePage";
import AccountSettingsPage from "../pages/app/Settings/AccountPage/AccountPage";

import AdminRoutes from "./admin.routes";

const AppRoutes: React.FC = () => {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route path="dashboard" element={<DashboardPage />} />
				<Route path="goals">
					<Route index element={<GoalListPage />} />
					<Route path=":goalId" element={<GoalDetailPage />} />
					<Route path="new" element={<GoalFormPage />} />
					<Route path=":goalId/edit" element={<GoalFormPage />} />
				</Route>
				<Route path="diary">
					<Route index element={<DiaryListPage />} />
					<Route path=":diaryId" element={<DiaryDetailPage />} />
					<Route path="new" element={<DiaryFormPage />} />
					<Route path=":diaryId/edit" element={<DiaryFormPage />} />
				</Route>
				<Route path="progress-tracker" element={<ProgressTrackerPage />} />
				<Route path="profile" element={<ProfilePage />} />
				<Route path="events">
					<Route index element={<EventListPage />} />
					<Route path=":eventId" element={<EventDetailPage />} />
					<Route path="new" element={<EventFormPage />} />
					<Route path=":eventId/edit" element={<EventFormPage />} />
				</Route>
				<Route path="channels">
					<Route path="" element={<ChannelListPage />} />
					<Route path=":channelId" element={<ChannelDetailPage />} />
				</Route>
				<Route path="settings">
					<Route path="notifications" element={<NotificationsPage />} />
					<Route path="profile" element={<ProfileSettingsPage />} />
					<Route path="account" element={<AccountSettingsPage />} />
				</Route>
				<Route path="calendar" element={<CalendarPage />} />
				<Route path="search" element={<SearchResultPage />} />
				<Route path="pomodoro" element={<PomodoroTimerPage />} />
				<Route path="admin/*" element={<AdminRoutes />} />
			</Route>
		</Routes>
	);
};

export default AppRoutes;
